<ng-container *ngFor="let position of positions">
  <div
    *ngIf="toastsByPosition().get(position)?.length"
    class="toast-container"
    [ngClass]="'toast-' + position"
  >
    <div
      *ngFor="let toast of toastsByPosition().get(position)"
      class="toast"
      [ngClass]="'toast-' + toast.status"
    >
      <div class="toast-content">
        <ng-container [ngSwitch]="toast.status">
          <umkt-icon
            *ngSwitchCase="'success'"
            [icon]="{ name: 'checkbox-circulo', type: 'mondrian-icons' }"
            size="sm"
            class="toast-icon"
          ></umkt-icon>

          <umkt-icon
            *ngSwitchCase="'error'"
            [icon]="{ name: 'error', type: 'material-icons' }"
            size="sm"
            class="toast-icon"
          ></umkt-icon>

          <umkt-icon
            *ngSwitchCase="'warning'"
            [icon]="{ name: 'warning', type: 'material-icons' }"
            size="sm"
            class="toast-icon"
          ></umkt-icon>

          <umkt-icon
            *ngSwitchCase="'info'"
            [icon]="{ name: 'info', type: 'material-icons' }"
            size="sm"
            class="toast-icon"
          ></umkt-icon>
        </ng-container>
        <p>{{ toast.message }}</p>

        <button
          *ngIf="toast.action"
          class="toast-action-btn"
          type="button"
          (click)="onActionClick(toast)"
        >
        {{ toast.action.label }}
      </button>
      </div>
      <button class="toast-close-btn" (click)="toastService.remove(toast.id)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</ng-container>
